/* src/components/Tabs/GeoProductionTab.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	add_flush_callback,
	append_hydration,
	assign,
	attr,
	bind,
	binding_callbacks,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	empty,
	get_spread_object,
	get_spread_update,
	group_outros,
	init,
	insert_hydration,
	listen,
	mount_component,
	safe_not_equal,
	set_data,
	space,
	text,
	toggle_class,
	transition_in,
	transition_out
} from "svelte/internal";

import Chart from '../Charts/Chart.svelte';
import Tabs from './Tabs.svelte';
import TabContent from './TabContent.svelte';
import EmbedModal from '../EmbedModal/EmbedModal.svelte';
import { onMount } from 'svelte';
import Tooltip from '../Tooltip/Tooltip.svelte';

function create_if_block_21(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { id: true });
			children(div).forEach(detach);
			this.h();
		},
		h() {
			attr(div, "id", /*embedDetector*/ ctx[8]);
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*embedDetector*/ 256) {
				attr(div, "id", /*embedDetector*/ ctx[8]);
			}
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (87:2) {#if titleTooltipText}
function create_if_block_20(ctx) {
	let tooltip;
	let current;

	tooltip = new Tooltip({
			props: { text: /*titleTooltipText*/ ctx[6] }
		});

	return {
		c() {
			create_component(tooltip.$$.fragment);
		},
		l(nodes) {
			claim_component(tooltip.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(tooltip, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const tooltip_changes = {};
			if (dirty & /*titleTooltipText*/ 64) tooltip_changes.text = /*titleTooltipText*/ ctx[6];
			tooltip.$set(tooltip_changes);
		},
		i(local) {
			if (current) return;
			transition_in(tooltip.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(tooltip.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(tooltip, detaching);
		}
	};
}

// (117:42) 
function create_if_block_11(ctx) {
	let div;
	let t0;
	let t1;
	let current_block_type_index;
	let if_block2;
	let if_block2_anchor;
	let current;
	let if_block0 = (/*datasets*/ ctx[2].emission.production.monthly.labels || /*datasets*/ ctx[2].emission.production.annual.labels) && (/*datasets*/ ctx[2].emission.production.monthly.labels.length > 0 || /*datasets*/ ctx[2].emission.production.annual.labels.length > 0) && create_if_block_19(ctx);
	let if_block1 = (/*datasets*/ ctx[2].emission.consumption.monthly.labels.length > 0 || /*datasets*/ ctx[2].emission.consumption.annual.labels.length > 0) && create_if_block_18(ctx);
	const if_block_creators = [create_if_block_12, create_if_block_15];
	const if_blocks = [];

	function select_block_type_3(ctx, dirty) {
		if (/*emissionsBy*/ ctx[0] === 'production' || /*emissionsBy*/ ctx[0] === 'processing') return 0;
		if (/*emissionsBy*/ ctx[0] === 'consumption') return 1;
		return -1;
	}

	if (~(current_block_type_index = select_block_type_3(ctx, -1))) {
		if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	}

	return {
		c() {
			div = element("div");
			if (if_block0) if_block0.c();
			t0 = space();
			if (if_block1) if_block1.c();
			t1 = space();
			if (if_block2) if_block2.c();
			if_block2_anchor = empty();
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			if (if_block0) if_block0.l(div_nodes);
			t0 = claim_space(div_nodes);
			if (if_block1) if_block1.l(div_nodes);
			div_nodes.forEach(detach);
			t1 = claim_space(nodes);
			if (if_block2) if_block2.l(nodes);
			if_block2_anchor = empty();
			this.h();
		},
		h() {
			attr(div, "class", "checkbox-group text-center svelte-1a4gq4l");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			if (if_block0) if_block0.m(div, null);
			append_hydration(div, t0);
			if (if_block1) if_block1.m(div, null);
			insert_hydration(target, t1, anchor);

			if (~current_block_type_index) {
				if_blocks[current_block_type_index].m(target, anchor);
			}

			insert_hydration(target, if_block2_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if ((/*datasets*/ ctx[2].emission.production.monthly.labels || /*datasets*/ ctx[2].emission.production.annual.labels) && (/*datasets*/ ctx[2].emission.production.monthly.labels.length > 0 || /*datasets*/ ctx[2].emission.production.annual.labels.length > 0)) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_19(ctx);
					if_block0.c();
					if_block0.m(div, t0);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*datasets*/ ctx[2].emission.consumption.monthly.labels.length > 0 || /*datasets*/ ctx[2].emission.consumption.annual.labels.length > 0) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_18(ctx);
					if_block1.c();
					if_block1.m(div, null);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_3(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				}
			} else {
				if (if_block2) {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
				}

				if (~current_block_type_index) {
					if_block2 = if_blocks[current_block_type_index];

					if (!if_block2) {
						if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block2.c();
					} else {
						if_block2.p(ctx, dirty);
					}

					transition_in(if_block2, 1);
					if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
				} else {
					if_block2 = null;
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block2);
			current = true;
		},
		o(local) {
			transition_out(if_block2);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (detaching) detach(t1);

			if (~current_block_type_index) {
				if_blocks[current_block_type_index].d(detaching);
			}

			if (detaching) detach(if_block2_anchor);
		}
	};
}

// (105:44) 
function create_if_block_7(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_8, create_if_block_9, create_if_block_10];
	const if_blocks = [];

	function select_block_type_2(ctx, dirty) {
		if (!/*alwaysShowFooter*/ ctx[4]) return 0;
		if (/*monthlyChart*/ ctx[12]) return 1;
		if (/*annualChart*/ ctx[13]) return 2;
		return -1;
	}

	if (~(current_block_type_index = select_block_type_2(ctx, -1))) {
		if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	}

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			if (if_block) if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (~current_block_type_index) {
				if_blocks[current_block_type_index].m(target, anchor);
			}

			insert_hydration(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_2(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				}
			} else {
				if (if_block) {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
				}

				if (~current_block_type_index) {
					if_block = if_blocks[current_block_type_index];

					if (!if_block) {
						if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block.c();
					} else {
						if_block.p(ctx, dirty);
					}

					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				} else {
					if_block = null;
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (~current_block_type_index) {
				if_blocks[current_block_type_index].d(detaching);
			}

			if (detaching) detach(if_block_anchor);
		}
	};
}

// (103:38) 
function create_if_block_6(ctx) {
	let chart;
	let current;
	const chart_spread_levels = [/*datasets*/ ctx[2].sales, { yLabel: /*yUnit*/ ctx[5] }, { xLabel: "Year" }];
	let chart_props = {};

	for (let i = 0; i < chart_spread_levels.length; i += 1) {
		chart_props = assign(chart_props, chart_spread_levels[i]);
	}

	chart = new Chart({ props: chart_props });

	return {
		c() {
			create_component(chart.$$.fragment);
		},
		l(nodes) {
			claim_component(chart.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(chart, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const chart_changes = (dirty & /*datasets, yUnit*/ 36)
			? get_spread_update(chart_spread_levels, [
					dirty & /*datasets*/ 4 && get_spread_object(/*datasets*/ ctx[2].sales),
					dirty & /*yUnit*/ 32 && { yLabel: /*yUnit*/ ctx[5] },
					chart_spread_levels[2]
				])
			: {};

			chart.$set(chart_changes);
		},
		i(local) {
			if (current) return;
			transition_in(chart.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(chart.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(chart, detaching);
		}
	};
}

// (93:2) {#if currentGeoTab === 'Production' || currentGeoTab === 'Processing'}
function create_if_block_3(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_4, create_if_block_5];
	const if_blocks = [];

	function select_block_type_1(ctx, dirty) {
		if (/*monthlyChart*/ ctx[12]) return 0;
		if (/*annualChart*/ ctx[13]) return 1;
		return -1;
	}

	if (~(current_block_type_index = select_block_type_1(ctx, -1))) {
		if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	}

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			if (if_block) if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (~current_block_type_index) {
				if_blocks[current_block_type_index].m(target, anchor);
			}

			insert_hydration(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_1(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				}
			} else {
				if (if_block) {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
				}

				if (~current_block_type_index) {
					if_block = if_blocks[current_block_type_index];

					if (!if_block) {
						if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block.c();
					} else {
						if_block.p(ctx, dirty);
					}

					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				} else {
					if_block = null;
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (~current_block_type_index) {
				if_blocks[current_block_type_index].d(detaching);
			}

			if (detaching) detach(if_block_anchor);
		}
	};
}

// (119:6) {#if (datasets.emission.production.monthly.labels || datasets.emission.production.annual.labels) && (datasets.emission.production.monthly.labels.length > 0 || datasets.emission.production.annual.labels.length > 0)}
function create_if_block_19(ctx) {
	let label;
	let input;
	let t0;
	let span;
	let t1;
	let t2_value = /*geoTabs*/ ctx[3][0] + "";
	let t2;
	let mounted;
	let dispose;

	return {
		c() {
			label = element("label");
			input = element("input");
			t0 = space();
			span = element("span");
			t1 = text("Emissions by ");
			t2 = text(t2_value);
			this.h();
		},
		l(nodes) {
			label = claim_element(nodes, "LABEL", { class: true });
			var label_nodes = children(label);
			input = claim_element(label_nodes, "INPUT", { type: true, class: true, name: true });
			t0 = claim_space(label_nodes);
			span = claim_element(label_nodes, "SPAN", { class: true });
			var span_nodes = children(span);
			t1 = claim_text(span_nodes, "Emissions by ");
			t2 = claim_text(span_nodes, t2_value);
			span_nodes.forEach(detach);
			label_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(input, "type", "radio");
			attr(input, "class", "checkbox__input");
			attr(input, "name", "emmissionChart");
			input.__value = "production";
			input.value = input.__value;
			/*$$binding_groups*/ ctx[17][0].push(input);
			attr(span, "class", "checkbox__label");
			attr(label, "class", "checkbox svelte-1a4gq4l");
		},
		m(target, anchor) {
			insert_hydration(target, label, anchor);
			append_hydration(label, input);
			input.checked = input.__value === /*emissionsBy*/ ctx[0];
			append_hydration(label, t0);
			append_hydration(label, span);
			append_hydration(span, t1);
			append_hydration(span, t2);

			if (!mounted) {
				dispose = listen(input, "change", /*input_change_handler*/ ctx[16]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*emissionsBy*/ 1) {
				input.checked = input.__value === /*emissionsBy*/ ctx[0];
			}

			if (dirty & /*geoTabs*/ 8 && t2_value !== (t2_value = /*geoTabs*/ ctx[3][0] + "")) set_data(t2, t2_value);
		},
		d(detaching) {
			if (detaching) detach(label);
			/*$$binding_groups*/ ctx[17][0].splice(/*$$binding_groups*/ ctx[17][0].indexOf(input), 1);
			mounted = false;
			dispose();
		}
	};
}

// (131:6) {#if datasets.emission.consumption.monthly.labels.length > 0 || datasets.emission.consumption.annual.labels.length > 0}
function create_if_block_18(ctx) {
	let label;
	let input;
	let t0;
	let span;
	let t1;
	let mounted;
	let dispose;

	return {
		c() {
			label = element("label");
			input = element("input");
			t0 = space();
			span = element("span");
			t1 = text("Emissions by Consumption");
			this.h();
		},
		l(nodes) {
			label = claim_element(nodes, "LABEL", { class: true });
			var label_nodes = children(label);
			input = claim_element(label_nodes, "INPUT", { type: true, class: true, name: true });
			t0 = claim_space(label_nodes);
			span = claim_element(label_nodes, "SPAN", { class: true });
			var span_nodes = children(span);
			t1 = claim_text(span_nodes, "Emissions by Consumption");
			span_nodes.forEach(detach);
			label_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(input, "type", "radio");
			attr(input, "class", "checkbox__input");
			attr(input, "name", "emmissionChart");
			input.__value = "consumption";
			input.value = input.__value;
			/*$$binding_groups*/ ctx[17][0].push(input);
			attr(span, "class", "checkbox__label");
			attr(label, "class", "checkbox svelte-1a4gq4l");
		},
		m(target, anchor) {
			insert_hydration(target, label, anchor);
			append_hydration(label, input);
			input.checked = input.__value === /*emissionsBy*/ ctx[0];
			append_hydration(label, t0);
			append_hydration(label, span);
			append_hydration(span, t1);

			if (!mounted) {
				dispose = listen(input, "change", /*input_change_handler_1*/ ctx[18]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*emissionsBy*/ 1) {
				input.checked = input.__value === /*emissionsBy*/ ctx[0];
			}
		},
		d(detaching) {
			if (detaching) detach(label);
			/*$$binding_groups*/ ctx[17][0].splice(/*$$binding_groups*/ ctx[17][0].indexOf(input), 1);
			mounted = false;
			dispose();
		}
	};
}

// (150:44) 
function create_if_block_15(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_16, create_if_block_17];
	const if_blocks = [];

	function select_block_type_5(ctx, dirty) {
		if (/*monthlyChart*/ ctx[12]) return 0;
		if (/*annualChart*/ ctx[13]) return 1;
		return -1;
	}

	if (~(current_block_type_index = select_block_type_5(ctx, -1))) {
		if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	}

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			if (if_block) if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (~current_block_type_index) {
				if_blocks[current_block_type_index].m(target, anchor);
			}

			insert_hydration(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_5(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				}
			} else {
				if (if_block) {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
				}

				if (~current_block_type_index) {
					if_block = if_blocks[current_block_type_index];

					if (!if_block) {
						if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block.c();
					} else {
						if_block.p(ctx, dirty);
					}

					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				} else {
					if_block = null;
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (~current_block_type_index) {
				if_blocks[current_block_type_index].d(detaching);
			}

			if (detaching) detach(if_block_anchor);
		}
	};
}

// (144:4) {#if emissionsBy === 'production' || emissionsBy === 'processing'}
function create_if_block_12(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_13, create_if_block_14];
	const if_blocks = [];

	function select_block_type_4(ctx, dirty) {
		if (/*monthlyChart*/ ctx[12]) return 0;
		if (/*annualChart*/ ctx[13]) return 1;
		return -1;
	}

	if (~(current_block_type_index = select_block_type_4(ctx, -1))) {
		if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	}

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			if (if_block) if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (~current_block_type_index) {
				if_blocks[current_block_type_index].m(target, anchor);
			}

			insert_hydration(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_4(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				}
			} else {
				if (if_block) {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
				}

				if (~current_block_type_index) {
					if_block = if_blocks[current_block_type_index];

					if (!if_block) {
						if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block.c();
					} else {
						if_block.p(ctx, dirty);
					}

					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				} else {
					if_block = null;
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (~current_block_type_index) {
				if_blocks[current_block_type_index].d(detaching);
			}

			if (detaching) detach(if_block_anchor);
		}
	};
}

// (153:28) 
function create_if_block_17(ctx) {
	let chart;
	let current;

	const chart_spread_levels = [
		/*datasets*/ ctx[2].emission.consumption.annual,
		{ yLabel: "kg CO₂" },
		{ xLabel: "Year" }
	];

	let chart_props = {};

	for (let i = 0; i < chart_spread_levels.length; i += 1) {
		chart_props = assign(chart_props, chart_spread_levels[i]);
	}

	chart = new Chart({ props: chart_props });

	return {
		c() {
			create_component(chart.$$.fragment);
		},
		l(nodes) {
			claim_component(chart.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(chart, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const chart_changes = (dirty & /*datasets*/ 4)
			? get_spread_update(chart_spread_levels, [
					get_spread_object(/*datasets*/ ctx[2].emission.consumption.annual),
					chart_spread_levels[1],
					chart_spread_levels[2]
				])
			: {};

			chart.$set(chart_changes);
		},
		i(local) {
			if (current) return;
			transition_in(chart.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(chart.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(chart, detaching);
		}
	};
}

// (151:6) {#if monthlyChart}
function create_if_block_16(ctx) {
	let chart;
	let current;

	const chart_spread_levels = [
		/*datasets*/ ctx[2].emission.consumption.monthly,
		{ yLabel: "kg CO₂" },
		{ xLabel: "Month" }
	];

	let chart_props = {};

	for (let i = 0; i < chart_spread_levels.length; i += 1) {
		chart_props = assign(chart_props, chart_spread_levels[i]);
	}

	chart = new Chart({ props: chart_props });

	return {
		c() {
			create_component(chart.$$.fragment);
		},
		l(nodes) {
			claim_component(chart.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(chart, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const chart_changes = (dirty & /*datasets*/ 4)
			? get_spread_update(chart_spread_levels, [
					get_spread_object(/*datasets*/ ctx[2].emission.consumption.monthly),
					chart_spread_levels[1],
					chart_spread_levels[2]
				])
			: {};

			chart.$set(chart_changes);
		},
		i(local) {
			if (current) return;
			transition_in(chart.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(chart.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(chart, detaching);
		}
	};
}

// (147:28) 
function create_if_block_14(ctx) {
	let chart;
	let current;

	const chart_spread_levels = [
		/*datasets*/ ctx[2].emission.production.annual,
		{ yLabel: "kg CO₂" },
		{ xLabel: "Year" }
	];

	let chart_props = {};

	for (let i = 0; i < chart_spread_levels.length; i += 1) {
		chart_props = assign(chart_props, chart_spread_levels[i]);
	}

	chart = new Chart({ props: chart_props });

	return {
		c() {
			create_component(chart.$$.fragment);
		},
		l(nodes) {
			claim_component(chart.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(chart, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const chart_changes = (dirty & /*datasets*/ 4)
			? get_spread_update(chart_spread_levels, [
					get_spread_object(/*datasets*/ ctx[2].emission.production.annual),
					chart_spread_levels[1],
					chart_spread_levels[2]
				])
			: {};

			chart.$set(chart_changes);
		},
		i(local) {
			if (current) return;
			transition_in(chart.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(chart.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(chart, detaching);
		}
	};
}

// (145:6) {#if monthlyChart}
function create_if_block_13(ctx) {
	let chart;
	let current;

	const chart_spread_levels = [
		/*datasets*/ ctx[2].emission.production.monthly,
		{ yLabel: "kg CO₂" },
		{ xLabel: "Month" }
	];

	let chart_props = {};

	for (let i = 0; i < chart_spread_levels.length; i += 1) {
		chart_props = assign(chart_props, chart_spread_levels[i]);
	}

	chart = new Chart({ props: chart_props });

	return {
		c() {
			create_component(chart.$$.fragment);
		},
		l(nodes) {
			claim_component(chart.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(chart, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const chart_changes = (dirty & /*datasets*/ 4)
			? get_spread_update(chart_spread_levels, [
					get_spread_object(/*datasets*/ ctx[2].emission.production.monthly),
					chart_spread_levels[1],
					chart_spread_levels[2]
				])
			: {};

			chart.$set(chart_changes);
		},
		i(local) {
			if (current) return;
			transition_in(chart.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(chart.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(chart, detaching);
		}
	};
}

// (112:26) 
function create_if_block_10(ctx) {
	let div;
	let chart;
	let current;

	const chart_spread_levels = [
		/*datasets*/ ctx[2].consumption.annual,
		{ yLabel: /*yUnit*/ ctx[5] },
		{ xLabel: "Year" }
	];

	let chart_props = {};

	for (let i = 0; i < chart_spread_levels.length; i += 1) {
		chart_props = assign(chart_props, chart_spread_levels[i]);
	}

	chart = new Chart({ props: chart_props });

	return {
		c() {
			div = element("div");
			create_component(chart.$$.fragment);
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { id: true });
			var div_nodes = children(div);
			claim_component(chart.$$.fragment, div_nodes);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "id", "chart2");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			mount_component(chart, div, null);
			current = true;
		},
		p(ctx, dirty) {
			const chart_changes = (dirty & /*datasets, yUnit*/ 36)
			? get_spread_update(chart_spread_levels, [
					dirty & /*datasets*/ 4 && get_spread_object(/*datasets*/ ctx[2].consumption.annual),
					dirty & /*yUnit*/ 32 && { yLabel: /*yUnit*/ ctx[5] },
					chart_spread_levels[2]
				])
			: {};

			chart.$set(chart_changes);
		},
		i(local) {
			if (current) return;
			transition_in(chart.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(chart.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(chart);
		}
	};
}

// (108:27) 
function create_if_block_9(ctx) {
	let div;
	let chart;
	let current;

	const chart_spread_levels = [
		/*datasets*/ ctx[2].consumption.monthly,
		{ yLabel: /*yUnit*/ ctx[5] },
		{ xLabel: "Month" }
	];

	let chart_props = {};

	for (let i = 0; i < chart_spread_levels.length; i += 1) {
		chart_props = assign(chart_props, chart_spread_levels[i]);
	}

	chart = new Chart({ props: chart_props });

	return {
		c() {
			div = element("div");
			create_component(chart.$$.fragment);
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { id: true });
			var div_nodes = children(div);
			claim_component(chart.$$.fragment, div_nodes);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "id", "chart1");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			mount_component(chart, div, null);
			current = true;
		},
		p(ctx, dirty) {
			const chart_changes = (dirty & /*datasets, yUnit*/ 36)
			? get_spread_update(chart_spread_levels, [
					dirty & /*datasets*/ 4 && get_spread_object(/*datasets*/ ctx[2].consumption.monthly),
					dirty & /*yUnit*/ 32 && { yLabel: /*yUnit*/ ctx[5] },
					chart_spread_levels[2]
				])
			: {};

			chart.$set(chart_changes);
		},
		i(local) {
			if (current) return;
			transition_in(chart.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(chart.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(chart);
		}
	};
}

// (106:4) {#if !alwaysShowFooter}
function create_if_block_8(ctx) {
	let chart;
	let current;

	const chart_spread_levels = [
		/*datasets*/ ctx[2].consumption,
		{ yLabel: /*yUnit*/ ctx[5] },
		{ xLabel: "Month" }
	];

	let chart_props = {};

	for (let i = 0; i < chart_spread_levels.length; i += 1) {
		chart_props = assign(chart_props, chart_spread_levels[i]);
	}

	chart = new Chart({ props: chart_props });

	return {
		c() {
			create_component(chart.$$.fragment);
		},
		l(nodes) {
			claim_component(chart.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(chart, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const chart_changes = (dirty & /*datasets, yUnit*/ 36)
			? get_spread_update(chart_spread_levels, [
					dirty & /*datasets*/ 4 && get_spread_object(/*datasets*/ ctx[2].consumption),
					dirty & /*yUnit*/ 32 && { yLabel: /*yUnit*/ ctx[5] },
					chart_spread_levels[2]
				])
			: {};

			chart.$set(chart_changes);
		},
		i(local) {
			if (current) return;
			transition_in(chart.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(chart.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(chart, detaching);
		}
	};
}

// (98:26) 
function create_if_block_5(ctx) {
	let div;
	let chart;
	let current;

	const chart_spread_levels = [
		/*datasets*/ ctx[2].production.annual,
		{ yLabel: /*yUnit*/ ctx[5] },
		{ xLabel: "Year" }
	];

	let chart_props = {};

	for (let i = 0; i < chart_spread_levels.length; i += 1) {
		chart_props = assign(chart_props, chart_spread_levels[i]);
	}

	chart = new Chart({ props: chart_props });

	return {
		c() {
			div = element("div");
			create_component(chart.$$.fragment);
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { id: true });
			var div_nodes = children(div);
			claim_component(chart.$$.fragment, div_nodes);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "id", "chart2");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			mount_component(chart, div, null);
			current = true;
		},
		p(ctx, dirty) {
			const chart_changes = (dirty & /*datasets, yUnit*/ 36)
			? get_spread_update(chart_spread_levels, [
					dirty & /*datasets*/ 4 && get_spread_object(/*datasets*/ ctx[2].production.annual),
					dirty & /*yUnit*/ 32 && { yLabel: /*yUnit*/ ctx[5] },
					chart_spread_levels[2]
				])
			: {};

			chart.$set(chart_changes);
		},
		i(local) {
			if (current) return;
			transition_in(chart.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(chart.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(chart);
		}
	};
}

// (94:4) {#if monthlyChart}
function create_if_block_4(ctx) {
	let div;
	let chart;
	let current;

	const chart_spread_levels = [
		/*datasets*/ ctx[2].production.monthly,
		{ yLabel: /*yUnit*/ ctx[5] },
		{ xLabel: "Month" }
	];

	let chart_props = {};

	for (let i = 0; i < chart_spread_levels.length; i += 1) {
		chart_props = assign(chart_props, chart_spread_levels[i]);
	}

	chart = new Chart({ props: chart_props });

	return {
		c() {
			div = element("div");
			create_component(chart.$$.fragment);
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { id: true });
			var div_nodes = children(div);
			claim_component(chart.$$.fragment, div_nodes);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "id", "chart1");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			mount_component(chart, div, null);
			current = true;
		},
		p(ctx, dirty) {
			const chart_changes = (dirty & /*datasets, yUnit*/ 36)
			? get_spread_update(chart_spread_levels, [
					dirty & /*datasets*/ 4 && get_spread_object(/*datasets*/ ctx[2].production.monthly),
					dirty & /*yUnit*/ 32 && { yLabel: /*yUnit*/ ctx[5] },
					chart_spread_levels[2]
				])
			: {};

			chart.$set(chart_changes);
		},
		i(local) {
			if (current) return;
			transition_in(chart.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(chart.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(chart);
		}
	};
}

// (158:2) {#if currentGeoTab === 'Production' || currentGeoTab === 'Emissions' || alwaysShowFooter}
function create_if_block_1(ctx) {
	let div1;
	let t0;
	let div0;
	let strong;
	let t1;
	let t2;
	let small;
	let t3;
	let t4;
	let t5;
	let t6;
	let t7;
	let t8;
	let t9;
	let t10_value = /*geoTabs*/ ctx[3][0].toLowerCase() + "";
	let t10;
	let t11;
	let a;
	let t12;
	let t13;
	let mounted;
	let dispose;
	let if_block = !(/*emissionsBy*/ ctx[0] === 'consumption' && /*datasets*/ ctx[2].emission.consumption.monthly.labels.length === 0) && create_if_block_2(ctx);

	return {
		c() {
			div1 = element("div");
			if (if_block) if_block.c();
			t0 = space();
			div0 = element("div");
			strong = element("strong");
			t1 = text("Annual");
			t2 = space();
			small = element("small");
			t3 = text("Annual data for ");
			t4 = text(PREVIOUSYEAR);
			t5 = text(" will be finalized in the fall of ");
			t6 = text(CURRENTYEAR);
			t7 = text(". Until that time, some data may\n          be incomplete. Data for ");
			t8 = text(CURRENTYEAR);
			t9 = text(" is a summation of all information released to date, which may only represent\n          a portion of the actual ");
			t10 = text(t10_value);
			t11 = text(" that has occurred. For clarification on any data points, please\n          ");
			a = element("a");
			t12 = text("contact");
			t13 = text(" our team.");
			this.h();
		},
		l(nodes) {
			div1 = claim_element(nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			if (if_block) if_block.l(div1_nodes);
			t0 = claim_space(div1_nodes);
			div0 = claim_element(div1_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			strong = claim_element(div0_nodes, "STRONG", {});
			var strong_nodes = children(strong);
			t1 = claim_text(strong_nodes, "Annual");
			strong_nodes.forEach(detach);
			t2 = claim_space(div0_nodes);
			small = claim_element(div0_nodes, "SMALL", {});
			var small_nodes = children(small);
			t3 = claim_text(small_nodes, "Annual data for ");
			t4 = claim_text(small_nodes, PREVIOUSYEAR);
			t5 = claim_text(small_nodes, " will be finalized in the fall of ");
			t6 = claim_text(small_nodes, CURRENTYEAR);
			t7 = claim_text(small_nodes, ". Until that time, some data may\n          be incomplete. Data for ");
			t8 = claim_text(small_nodes, CURRENTYEAR);
			t9 = claim_text(small_nodes, " is a summation of all information released to date, which may only represent\n          a portion of the actual ");
			t10 = claim_text(small_nodes, t10_value);
			t11 = claim_text(small_nodes, " that has occurred. For clarification on any data points, please\n          ");
			a = claim_element(small_nodes, "A", { href: true });
			var a_nodes = children(a);
			t12 = claim_text(a_nodes, "contact");
			a_nodes.forEach(detach);
			t13 = claim_text(small_nodes, " our team.");
			small_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(a, "href", "/contact/");
			attr(div0, "class", "btn");
			toggle_class(div0, "active", /*annualChart*/ ctx[13] == true);
			attr(div1, "class", "tab-content__footer");
		},
		m(target, anchor) {
			insert_hydration(target, div1, anchor);
			if (if_block) if_block.m(div1, null);
			append_hydration(div1, t0);
			append_hydration(div1, div0);
			append_hydration(div0, strong);
			append_hydration(strong, t1);
			append_hydration(div0, t2);
			append_hydration(div0, small);
			append_hydration(small, t3);
			append_hydration(small, t4);
			append_hydration(small, t5);
			append_hydration(small, t6);
			append_hydration(small, t7);
			append_hydration(small, t8);
			append_hydration(small, t9);
			append_hydration(small, t10);
			append_hydration(small, t11);
			append_hydration(small, a);
			append_hydration(a, t12);
			append_hydration(small, t13);

			if (!mounted) {
				dispose = listen(div0, "click", /*click_handler_1*/ ctx[20]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (!(/*emissionsBy*/ ctx[0] === 'consumption' && /*datasets*/ ctx[2].emission.consumption.monthly.labels.length === 0)) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_2(ctx);
					if_block.c();
					if_block.m(div1, t0);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty & /*geoTabs*/ 8 && t10_value !== (t10_value = /*geoTabs*/ ctx[3][0].toLowerCase() + "")) set_data(t10, t10_value);

			if (dirty & /*annualChart*/ 8192) {
				toggle_class(div0, "active", /*annualChart*/ ctx[13] == true);
			}
		},
		d(detaching) {
			if (detaching) detach(div1);
			if (if_block) if_block.d();
			mounted = false;
			dispose();
		}
	};
}

// (161:6) {#if !(emissionsBy === 'consumption' && datasets.emission.consumption.monthly.labels.length === 0)}
function create_if_block_2(ctx) {
	let div;
	let strong;
	let t0;
	let t1;
	let small;
	let t2;
	let t3_value = /*geoTabs*/ ctx[3][0].toLowerCase() + "";
	let t3;
	let t4;
	let t5;
	let t6;
	let t7;
	let t8;
	let a;
	let t9;
	let t10;
	let mounted;
	let dispose;

	return {
		c() {
			div = element("div");
			strong = element("strong");
			t0 = text("Monthly");
			t1 = space();
			small = element("small");
			t2 = text("We report ");
			t3 = text(t3_value);
			t4 = text(" data as it is published. Due to reporting methods and timing, data from\n            ");
			t5 = text(CURRENTYEAR);
			t6 = text(" and\n            ");
			t7 = text(PREVIOUSYEAR);
			t8 = text(" may be incomplete. Data is released in full each fall for the previous calendar year. For clarification\n            on any data points, please ");
			a = element("a");
			t9 = text("contact");
			t10 = text(" our team.");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			strong = claim_element(div_nodes, "STRONG", {});
			var strong_nodes = children(strong);
			t0 = claim_text(strong_nodes, "Monthly");
			strong_nodes.forEach(detach);
			t1 = claim_space(div_nodes);
			small = claim_element(div_nodes, "SMALL", {});
			var small_nodes = children(small);
			t2 = claim_text(small_nodes, "We report ");
			t3 = claim_text(small_nodes, t3_value);
			t4 = claim_text(small_nodes, " data as it is published. Due to reporting methods and timing, data from\n            ");
			t5 = claim_text(small_nodes, CURRENTYEAR);
			t6 = claim_text(small_nodes, " and\n            ");
			t7 = claim_text(small_nodes, PREVIOUSYEAR);
			t8 = claim_text(small_nodes, " may be incomplete. Data is released in full each fall for the previous calendar year. For clarification\n            on any data points, please ");
			a = claim_element(small_nodes, "A", { href: true });
			var a_nodes = children(a);
			t9 = claim_text(a_nodes, "contact");
			a_nodes.forEach(detach);
			t10 = claim_text(small_nodes, " our team.");
			small_nodes.forEach(detach);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(a, "href", "/contact/");
			attr(div, "class", "btn");
			toggle_class(div, "active", /*monthlyChart*/ ctx[12] == true);
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			append_hydration(div, strong);
			append_hydration(strong, t0);
			append_hydration(div, t1);
			append_hydration(div, small);
			append_hydration(small, t2);
			append_hydration(small, t3);
			append_hydration(small, t4);
			append_hydration(small, t5);
			append_hydration(small, t6);
			append_hydration(small, t7);
			append_hydration(small, t8);
			append_hydration(small, a);
			append_hydration(a, t9);
			append_hydration(small, t10);

			if (!mounted) {
				dispose = listen(div, "click", /*click_handler*/ ctx[19]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*geoTabs*/ 8 && t3_value !== (t3_value = /*geoTabs*/ ctx[3][0].toLowerCase() + "")) set_data(t3, t3_value);

			if (dirty & /*monthlyChart*/ 4096) {
				toggle_class(div, "active", /*monthlyChart*/ ctx[12] == true);
			}
		},
		d(detaching) {
			if (detaching) detach(div);
			mounted = false;
			dispose();
		}
	};
}

// (92:0) <TabContent>
function create_default_slot(ctx) {
	let current_block_type_index;
	let if_block0;
	let t;
	let if_block1_anchor;
	let current;
	const if_block_creators = [create_if_block_3, create_if_block_6, create_if_block_7, create_if_block_11];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*currentGeoTab*/ ctx[10] === 'Production' || /*currentGeoTab*/ ctx[10] === 'Processing') return 0;
		if (/*currentGeoTab*/ ctx[10] === 'Sales') return 1;
		if (/*currentGeoTab*/ ctx[10] === 'Consumption') return 2;
		if (/*currentGeoTab*/ ctx[10] === 'Emissions') return 3;
		return -1;
	}

	if (~(current_block_type_index = select_block_type(ctx, -1))) {
		if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	}

	let if_block1 = (/*currentGeoTab*/ ctx[10] === 'Production' || /*currentGeoTab*/ ctx[10] === 'Emissions' || /*alwaysShowFooter*/ ctx[4]) && create_if_block_1(ctx);

	return {
		c() {
			if (if_block0) if_block0.c();
			t = space();
			if (if_block1) if_block1.c();
			if_block1_anchor = empty();
		},
		l(nodes) {
			if (if_block0) if_block0.l(nodes);
			t = claim_space(nodes);
			if (if_block1) if_block1.l(nodes);
			if_block1_anchor = empty();
		},
		m(target, anchor) {
			if (~current_block_type_index) {
				if_blocks[current_block_type_index].m(target, anchor);
			}

			insert_hydration(target, t, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert_hydration(target, if_block1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				}
			} else {
				if (if_block0) {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
				}

				if (~current_block_type_index) {
					if_block0 = if_blocks[current_block_type_index];

					if (!if_block0) {
						if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block0.c();
					} else {
						if_block0.p(ctx, dirty);
					}

					transition_in(if_block0, 1);
					if_block0.m(t.parentNode, t);
				} else {
					if_block0 = null;
				}
			}

			if (/*currentGeoTab*/ ctx[10] === 'Production' || /*currentGeoTab*/ ctx[10] === 'Emissions' || /*alwaysShowFooter*/ ctx[4]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_1(ctx);
					if_block1.c();
					if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			current = false;
		},
		d(detaching) {
			if (~current_block_type_index) {
				if_blocks[current_block_type_index].d(detaching);
			}

			if (detaching) detach(t);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(if_block1_anchor);
		}
	};
}

// (184:0) {#if componentEmbedId || debugEmbedId}
function create_if_block(ctx) {
	let embedmodal;
	let updating_isModalOpen;
	let current;

	function embedmodal_isModalOpen_binding(value) {
		/*embedmodal_isModalOpen_binding*/ ctx[21](value);
	}

	let embedmodal_props = {
		componentEmbedId: /*componentEmbedId*/ ctx[1] || debugEmbedId,
		embedOrigin: /*embedOrigin*/ ctx[9],
		buttonClasses: "margin-top"
	};

	if (/*isModalOpen*/ ctx[11] !== void 0) {
		embedmodal_props.isModalOpen = /*isModalOpen*/ ctx[11];
	}

	embedmodal = new EmbedModal({ props: embedmodal_props });
	binding_callbacks.push(() => bind(embedmodal, 'isModalOpen', embedmodal_isModalOpen_binding));

	return {
		c() {
			create_component(embedmodal.$$.fragment);
		},
		l(nodes) {
			claim_component(embedmodal.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(embedmodal, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const embedmodal_changes = {};
			if (dirty & /*componentEmbedId*/ 2) embedmodal_changes.componentEmbedId = /*componentEmbedId*/ ctx[1] || debugEmbedId;
			if (dirty & /*embedOrigin*/ 512) embedmodal_changes.embedOrigin = /*embedOrigin*/ ctx[9];

			if (!updating_isModalOpen && dirty & /*isModalOpen*/ 2048) {
				updating_isModalOpen = true;
				embedmodal_changes.isModalOpen = /*isModalOpen*/ ctx[11];
				add_flush_callback(() => updating_isModalOpen = false);
			}

			embedmodal.$set(embedmodal_changes);
		},
		i(local) {
			if (current) return;
			transition_in(embedmodal.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(embedmodal.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(embedmodal, detaching);
		}
	};
}

function create_fragment(ctx) {
	let t0;
	let h2;
	let t1;
	let t2;
	let t3;
	let tabs;
	let updating_activeTab;
	let t4;
	let tabcontent;
	let t5;
	let if_block2_anchor;
	let current;
	let if_block0 = /*embedDetector*/ ctx[8] && create_if_block_21(ctx);
	let if_block1 = /*titleTooltipText*/ ctx[6] && create_if_block_20(ctx);

	function tabs_activeTab_binding(value) {
		/*tabs_activeTab_binding*/ ctx[15](value);
	}

	let tabs_props = {
		items: /*geoTabs*/ ctx[3],
		customClass: "tab-nav--underlined"
	};

	if (/*currentGeoTab*/ ctx[10] !== void 0) {
		tabs_props.activeTab = /*currentGeoTab*/ ctx[10];
	}

	tabs = new Tabs({ props: tabs_props });
	binding_callbacks.push(() => bind(tabs, 'activeTab', tabs_activeTab_binding));

	tabcontent = new TabContent({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	let if_block2 = (/*componentEmbedId*/ ctx[1] || debugEmbedId) && create_if_block(ctx);

	return {
		c() {
			if (if_block0) if_block0.c();
			t0 = space();
			h2 = element("h2");
			t1 = text(/*title*/ ctx[7]);
			t2 = space();
			if (if_block1) if_block1.c();
			t3 = space();
			create_component(tabs.$$.fragment);
			t4 = space();
			create_component(tabcontent.$$.fragment);
			t5 = space();
			if (if_block2) if_block2.c();
			if_block2_anchor = empty();
			this.h();
		},
		l(nodes) {
			if (if_block0) if_block0.l(nodes);
			t0 = claim_space(nodes);
			h2 = claim_element(nodes, "H2", { id: true, class: true });
			var h2_nodes = children(h2);
			t1 = claim_text(h2_nodes, /*title*/ ctx[7]);
			t2 = claim_space(h2_nodes);
			if (if_block1) if_block1.l(h2_nodes);
			h2_nodes.forEach(detach);
			t3 = claim_space(nodes);
			claim_component(tabs.$$.fragment, nodes);
			t4 = claim_space(nodes);
			claim_component(tabcontent.$$.fragment, nodes);
			t5 = claim_space(nodes);
			if (if_block2) if_block2.l(nodes);
			if_block2_anchor = empty();
			this.h();
		},
		h() {
			attr(h2, "id", "geo-charts");
			attr(h2, "class", "heading-sm svelte-1a4gq4l");
		},
		m(target, anchor) {
			if (if_block0) if_block0.m(target, anchor);
			insert_hydration(target, t0, anchor);
			insert_hydration(target, h2, anchor);
			append_hydration(h2, t1);
			append_hydration(h2, t2);
			if (if_block1) if_block1.m(h2, null);
			insert_hydration(target, t3, anchor);
			mount_component(tabs, target, anchor);
			insert_hydration(target, t4, anchor);
			mount_component(tabcontent, target, anchor);
			insert_hydration(target, t5, anchor);
			if (if_block2) if_block2.m(target, anchor);
			insert_hydration(target, if_block2_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*embedDetector*/ ctx[8]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_21(ctx);
					if_block0.c();
					if_block0.m(t0.parentNode, t0);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (!current || dirty & /*title*/ 128) set_data(t1, /*title*/ ctx[7]);

			if (/*titleTooltipText*/ ctx[6]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty & /*titleTooltipText*/ 64) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_20(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(h2, null);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			const tabs_changes = {};
			if (dirty & /*geoTabs*/ 8) tabs_changes.items = /*geoTabs*/ ctx[3];

			if (!updating_activeTab && dirty & /*currentGeoTab*/ 1024) {
				updating_activeTab = true;
				tabs_changes.activeTab = /*currentGeoTab*/ ctx[10];
				add_flush_callback(() => updating_activeTab = false);
			}

			tabs.$set(tabs_changes);
			const tabcontent_changes = {};

			if (dirty & /*$$scope, annualChart, geoTabs, monthlyChart, emissionsBy, datasets, currentGeoTab, alwaysShowFooter, yUnit*/ 4207677) {
				tabcontent_changes.$$scope = { dirty, ctx };
			}

			tabcontent.$set(tabcontent_changes);

			if (/*componentEmbedId*/ ctx[1] || debugEmbedId) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty & /*componentEmbedId*/ 2) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block1);
			transition_in(tabs.$$.fragment, local);
			transition_in(tabcontent.$$.fragment, local);
			transition_in(if_block2);
			current = true;
		},
		o(local) {
			transition_out(if_block1);
			transition_out(tabs.$$.fragment, local);
			transition_out(tabcontent.$$.fragment, local);
			transition_out(if_block2);
			current = false;
		},
		d(detaching) {
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t0);
			if (detaching) detach(h2);
			if (if_block1) if_block1.d();
			if (detaching) detach(t3);
			destroy_component(tabs, detaching);
			if (detaching) detach(t4);
			destroy_component(tabcontent, detaching);
			if (detaching) detach(t5);
			if (if_block2) if_block2.d(detaching);
			if (detaching) detach(if_block2_anchor);
		}
	};
}

let debugEmbedId = '';
let PREVIOUSYEAR = 2022;
let CURRENTYEAR = 2023;

function instance($$self, $$props, $$invalidate) {
	let { datasets } = $$props;
	let { geoTabs = ['Production', 'Consumption', 'Emissions'] } = $$props;
	let { emissionsBy = 'production' } = $$props;
	let { alwaysShowFooter = false } = $$props;
	let { yUnit = 'MWh' } = $$props;
	let { titleTooltipText = '' } = $$props;
	let { title } = $$props;
	let { componentEmbedId } = $$props;
	let { embedDetector } = $$props;
	let { embedOrigin } = $$props;
	let isModalOpen = false;

	onMount(() => {
		if (!embedDetector) {
			console.warn('No embed detector provided');
			return;
		}

		const component = document.getElementById(embedDetector);

		if (!component) {
			console.warn('No component found with the provided embed detector ID:', embedDetector);
			return;
		}

		const embedDetectorDivParent = component.parentElement;

		if (!embedDetectorDivParent) {
			console.warn('No parent element found for the embed detector');
			return;
		}

		const embedId = embedDetectorDivParent.getAttribute('data-embed-id');

		if (!embedId) {
			console.warn('No embed ID found on the component');
			return;
		}

		$$invalidate(1, componentEmbedId = embedId);
	});

	let currentGeoTab;

	// CHART
	let monthlyChart = true;

	let annualChart = false;

	let switchChart = chartType => {
		if (chartType === 'monthlyChart') {
			$$invalidate(12, monthlyChart = true);
			$$invalidate(13, annualChart = false);
		} else if (chartType === 'annualChart') {
			$$invalidate(13, annualChart = true);
			$$invalidate(12, monthlyChart = false);
		}
	};

	const $$binding_groups = [[]];

	function tabs_activeTab_binding(value) {
		currentGeoTab = value;
		$$invalidate(10, currentGeoTab);
	}

	function input_change_handler() {
		emissionsBy = this.__value;
		$$invalidate(0, emissionsBy);
	}

	function input_change_handler_1() {
		emissionsBy = this.__value;
		$$invalidate(0, emissionsBy);
	}

	const click_handler = () => switchChart('monthlyChart');
	const click_handler_1 = () => switchChart('annualChart');

	function embedmodal_isModalOpen_binding(value) {
		isModalOpen = value;
		$$invalidate(11, isModalOpen);
	}

	$$self.$$set = $$props => {
		if ('datasets' in $$props) $$invalidate(2, datasets = $$props.datasets);
		if ('geoTabs' in $$props) $$invalidate(3, geoTabs = $$props.geoTabs);
		if ('emissionsBy' in $$props) $$invalidate(0, emissionsBy = $$props.emissionsBy);
		if ('alwaysShowFooter' in $$props) $$invalidate(4, alwaysShowFooter = $$props.alwaysShowFooter);
		if ('yUnit' in $$props) $$invalidate(5, yUnit = $$props.yUnit);
		if ('titleTooltipText' in $$props) $$invalidate(6, titleTooltipText = $$props.titleTooltipText);
		if ('title' in $$props) $$invalidate(7, title = $$props.title);
		if ('componentEmbedId' in $$props) $$invalidate(1, componentEmbedId = $$props.componentEmbedId);
		if ('embedDetector' in $$props) $$invalidate(8, embedDetector = $$props.embedDetector);
		if ('embedOrigin' in $$props) $$invalidate(9, embedOrigin = $$props.embedOrigin);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*currentGeoTab, emissionsBy, datasets*/ 1029) {
			$: if (currentGeoTab === 'Emissions' && emissionsBy === 'consumption' && datasets.emission.consumption.monthly.labels.length === 0) {
				switchChart('annualChart');
			}
		}
	};

	return [
		emissionsBy,
		componentEmbedId,
		datasets,
		geoTabs,
		alwaysShowFooter,
		yUnit,
		titleTooltipText,
		title,
		embedDetector,
		embedOrigin,
		currentGeoTab,
		isModalOpen,
		monthlyChart,
		annualChart,
		switchChart,
		tabs_activeTab_binding,
		input_change_handler,
		$$binding_groups,
		input_change_handler_1,
		click_handler,
		click_handler_1,
		embedmodal_isModalOpen_binding
	];
}

class GeoProductionTab extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			datasets: 2,
			geoTabs: 3,
			emissionsBy: 0,
			alwaysShowFooter: 4,
			yUnit: 5,
			titleTooltipText: 6,
			title: 7,
			componentEmbedId: 1,
			embedDetector: 8,
			embedOrigin: 9
		});
	}
}

export default GeoProductionTab;